<script>
export default {
    name: 'UserCreationForm',
    props: {
        onformsubmit: {
            type: Function,
            required: true
            },
        validator: {
            type: Object,
            required: true
            },
        form: {
            type: Object,
            required: true
            },
        isthirdpartyuser: {
            type: Boolean,
            default: false,
            required: true
            },
        thirdparty: {
            type: String,
            required: false
        }
        
    },
    data() {
        return {}
    },
    mounted() {
        this.form.is_thirdparty_user = this.isthirdpartyuser
        if (this.isthirdpartyuser) {
            this.form.thirdparty = this.thirdparty
        }
    },
    methods: {
        pass() {
            this.form.repeat_password = this.form.password
        }
    }
}
</script>
<template>
    <b-form  id="form" @submit="onformsubmit" >
        <!-- {{form}} -->
        <form-wrapper :validator="validator ">
        <!-- <div>
            <form-summary/>
        </div> -->
        <form-group v-if="!isthirdpartyuser" name="username" :label="$t('username')">
            <b-form-input
                class="border-primary"
                v-model="form.username"
                slot-scope="{ attrs, listeners }"
                v-bind="attrs"
                v-on="listeners"
            /> 
        </form-group>
        <form-group  v-else name="username" :label="`${$t('username')} (${$t('email')})`">
            <b-form-input
                class="border-primary"
                v-model="form.username"
                slot-scope="{ attrs, listeners }"
                v-bind="attrs"
                v-on="listeners"
            /> 
        </form-group>
        <form-group v-if="!isthirdpartyuser" name="password" :label="$t('password')">
            <b-form-input
                class="border-primary"
                v-model="form.password"
                slot-scope="{ attrs, listeners }"
                type="password"
                v-bind="attrs"
                v-on="listeners"
            /> 
        </form-group>
        <form-group v-if="!isthirdpartyuser" name="repeat_password" :label="$t('repeat_password')">
            <b-form-input
                class="border-primary"
                v-model="form.repeat_password"
                slot-scope="{ attrs, listeners }"
                type="password"
                v-bind="attrs"
                v-on="listeners"
            /> 
        </form-group>
        <form-group v-if="isthirdpartyuser" name="password" :label="`${$t('document')}`">
            <b-form-input
            
            class="border-primary"
                v-model="form.password"
                @input="pass()"
                slot-scope="{ attrs, listeners }"
                v-bind="attrs"
                v-on="listeners"
            /> 
        </form-group>          
        </form-wrapper>
    </b-form>
</template>